//https://reactnavigation.org/docs/configuring-links/#passing-params
//important links: https://reactnavigation.org/blog/2020/05/16/web-support/

import { createNativeStackNavigator } from "@react-navigation/native-stack";
import React from "react";
import { View, StyleSheet } from "react-native";
import NoFoundController from "../common/controllers/NoFoundController";
import routes from "./routes";
import MarketingController from "../marketing/controllers/MarketingController";
import PlansController from "../marketing/controllers/PlansController";
import BusinessController from "../marketing/controllers/BusinessController";
import MobileController from "../marketing/controllers/MobileController";
import GovermentController from "../marketing/controllers/GovermentController";
import DashboardController from "../dashboard/controllers/DashboardController";
import AdminController from "../admin/controllers/AdminController";
import DidController from "../admin/controllers/DidController";
import AdminNavigator from "./AdminNavigator";
import AdminRootController from "../admin/controllers/AdminRootController";
import WholesaleRootController from "../wholesale/controllers/WholesaleRootController";
import ImpactStudyController from "../marketing/controllers/ImpactStudyController";
import TosController from "../marketing/controllers/TosController";
import PatentController from "../marketing/controllers/PatentController";
import PrivacyController from "../marketing/controllers/PrivacyController";
import AboutUsController from "../marketing/controllers/AboutUsController";
import DevopsController from "../marketing/controllers/DevopsController";
import E911ServiceController from "../marketing/controllers/E911ServiceController";
import HospitalityController from "../marketing/controllers/HospitalityController";

const Stack = createNativeStackNavigator();

function AppNavigator({ onControllerChanged, initialRoute }) {
  return (
    <Stack.Navigator
      initialRouteName={initialRoute}
      screenListeners={{
        state: (e) => {
          const controller =
            e.data.state.routes[e.data.state.routes.length - 1].name;
          if (onControllerChanged) {
            onControllerChanged(controller);
          }
        },
      }}
      screenOptions={{ headerShown: false }}
    >
      <Stack.Screen
        name={routes.dashboard}
        component={DashboardController}
        options={{ title: "NTCONNECT | Dashboard" }}
      />

      <Stack.Screen
        name={routes.admin}
        component={AdminRootController}
        options={{ title: "NTCONNECT | Admin" }}
      />

      <Stack.Screen
        name={routes.wholesale}
        component={WholesaleRootController}
        options={{ title: "NTCONNECT | Wholesale" }}
      />

      <Stack.Screen
        name={routes.marketing}
        component={MarketingController}
        options={{ title: "NTCONNECT | Marketing" }}
      />

      <Stack.Screen
        name={routes.plans}
        component={PlansController}
        options={{ title: "NTCONNECT | Marketing" }}
      />

      <Stack.Screen
        name={routes.business}
        component={BusinessController}
        options={{ title: "NTCONNECT | Business" }}
      />

      <Stack.Screen
        name={routes.mobile}
        component={MobileController}
        options={{ title: "NTCONNECT | Mobile" }}
      />

      <Stack.Screen
        name={routes.hospitality}
        component={HospitalityController}
        options={{ title: "NTCONNECT | Hospitality" }}
      />

      <Stack.Screen
        name={routes.impactstudy}
        component={ImpactStudyController}
        options={{ title: "NTCONNECT | Impact Study" }}
      />

      <Stack.Screen
        name={routes.gov}
        component={GovermentController}
        options={{ title: "NTCONNECT | Gov" }}
      />

      <Stack.Screen
        name={routes.tos}
        component={TosController}
        options={{ title: "NTCONNECT | Terms of Service" }}
      />

      <Stack.Screen
        name={routes.patent}
        component={PatentController}
        options={{ title: "NTCONNECT | Patents" }}
      />

      <Stack.Screen
        name={routes.privacy}
        component={PrivacyController}
        options={{ title: "NTCONNECT | Privacy Policy" }}
      />

      <Stack.Screen
        name={routes.aboutus}
        component={AboutUsController}
        options={{ title: "NTCONNECT | About Us" }}
      />

      <Stack.Screen
        name={routes.e911}
        component={E911ServiceController}
        options={{ title: "NTCONNECT | Enterprises 911 Service" }}
      />

      <Stack.Screen
        name={routes.devops}
        component={DevopsController}
        options={{ title: "NTCONNECT | DevOps Enterprise" }}
      />

      <Stack.Screen
        name={routes.notfound}
        component={NoFoundController}
        options={{ title: "NTCONNECT | No Found" }}
      />
    </Stack.Navigator>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default AppNavigator;
